import {SERVER} from "../constants";
import {stringify} from "query-string";
import {MAP_URL} from "../constants/urls";
import {HttpClient} from "../utils/requests";
import {fixGetManyProductCategories} from "../panels/productCategory/productCategoryMapper";
import {fixGetManyProduct} from "../panels/product/productMapper";

import {fixGetManyNeedCategories} from "../panels/needCategory/needCategoryMapper";
import {fixGetManyUnits} from "../panels/essentials/unit/unitMapper";
import {fixGetMany} from "../panels/essentials/unitProcessor/unitProcessorMapper";
import {fixGetManyStatus} from "../panels/essentials/status/statusMapper";
import {fixGetManyStatusLoading} from "../panels/essentials/statusLoading/statusLoadingMapper";

import { fixGetManyReport } from "../panels/report/reportMapper";
import {fixGetManyLoadingRequest} from "../panels/loadingRequest/loadingRequestMapper";
import {fixGetManyWhatsapp} from "../panels/whatsapp/whatsappMapper";
import {fixGetManyCustomer} from "../panels/crm/customer/customerMapper";
import { fixGetManyPreferCall } from "../panels/essentials/preferCall/preferCallMapper";
import { fixGetManyStatusCall } from "../panels/essentials/statusCall/statusCallMapper";
import { fixGetManyPackages } from "../panels/essentials/package/packageMapper";
import { fixGetManyOrderTypes } from "../panels/essentials/orderType/orderTypeMapper";
import { fixGetManyContact } from "../panels/crm/contact/contactMapper";
import { fixGetManyAdminUser } from "../panels/adminUsers/adminUsersMapper";
import { fixGetManyCustomerCategorys } from "../panels/crm/essentials/customerCategory/customerCategoryMapper";
import { fixGetManyContactCategorys } from "../panels/crm/essentials/contactCategory/contactCategoryMapper";
import { fixGetManyCustomerPriority } from "../panels/crm/essentials/customerPriority/customerPriorityMapper";
import { fixGetManyCustomerRating } from "../panels/crm/essentials/customerRating/customerRatingMapper";
import { fixGetManyStorages } from "../panels/essentials/storage/storageMapper";
import { fixGetManyClue } from "../panels/crm/clue/clueMapper";
import { fixGetManyReminder } from "../panels/crm/reminder/reminderMapper";
import { fixGetManySendSMSs } from "../panels/essentials/sms/SendSMSMapper";
import { fixGetManyNotificationss } from '../panels/essentials/notifications/NotificationsMapper';
import { fixGetManyTransaction } from "../panels/transaction/transactionMapper";
import { fixGetManyBaseUnit } from "../panels/product/details/baseUnit/baseUnitMapper";
import { fixGetManyProductUnit } from "../panels/product/details/productUnit/productUnitMapper";
import { fixGetManyRawMaterial } from "../panels/product/details/rawMaterial/rawMaterialMapper";
import { fixGetManyProductCapacity } from "../panels/productCapacity/productCapacityMapper";
import { fixGetManyEventPanel } from "../panels/event/eventMapper";
import { fixGetManyReportInputProduct } from "../panels/reportInputProducts/reportInputProductsMapper";
import { fixGetManyReportProduction } from "../panels/reportProduction/reportProductionMapper";

export function getMany(resource, params) {

  const query = {
    filter: JSON.stringify({id: params.objectId}),
  };
  const url = `${SERVER}/${MAP_URL[resource]}?${stringify(query)}`;
  return HttpClient(url).then(({headers,json}) => {
    if (resource === 'productCategory') {
        return fixGetManyProductCategories(json);
      }else if(resource === 'adminUsers'){
        return fixGetManyAdminUser(headers,json);
      }else if(resource === 'product'){
        return fixGetManyProduct(json);
      }else if(resource === 'needCategory'){
        return fixGetManyNeedCategories(json);
      }else if(resource === 'unit' ){
        return fixGetManyUnits(json);
      }else if(resource === 'unitProcessor' ){
        return fixGetMany(json);
      }else if(resource === 'status' ){
        return fixGetManyStatus(json);
      }else if(resource === 'statusCall' ){
        return fixGetManyStatusCall(json);

      } else if (resource === 'preferCall') {
        return fixGetManyPreferCall(json);
      }else if(resource === 'loadingRequest' ){
        return fixGetManyLoadingRequest(json);
      }else if(resource === 'statusLoading' ){
        return fixGetManyStatusLoading(json);
      }else if(resource === 'report' ){
        return fixGetManyReport(json);
      }else if(resource === 'reportProduction' ){
        return fixGetManyReportProduction(json);
      }else if(resource === 'reportInputProduct' ){
        return fixGetManyReportInputProduct(json);
      }else if(resource === 'whatsapp' ){
        return fixGetManyWhatsapp(json);
      }else if(resource === 'customer' ){
        return fixGetManyCustomer(json);
      }else if(resource === 'contact' ){
        return fixGetManyContact(json);
      }else if(resource === 'package' ){
        return fixGetManyPackages(json);
      }else if(resource === 'orderType' ){
        return fixGetManyOrderTypes(json);
      }else if(resource === 'customerCategory' ){
        return fixGetManyCustomerCategorys(json);
      }else if(resource === 'contactCategory' ){
        return fixGetManyContactCategorys(json);
      }else if(resource === 'customerPriority' ){
        return fixGetManyCustomerPriority(json);
      }else if(resource === 'customerRating' ){
        return fixGetManyCustomerRating(json);
      }else if(resource === 'storage' ){
        return fixGetManyStorages(json);
      }else if(resource === 'clue' ){
        return fixGetManyClue(json);
      }else if(resource === 'reminder' ){
        return fixGetManyReminder(json);
      }else if(resource === 'sendSMS' ){
        return fixGetManySendSMSs(json);
      }else if(resource === 'notifications' ){
        return fixGetManyNotificationss(json);
      }else if(resource === 'transaction' ){
        return fixGetManyTransaction(json);
      }else if(resource === 'baseUnit' ){
        return fixGetManyBaseUnit(json);
      }else if(resource === 'productUnit' ){
        return fixGetManyProductUnit(json);
      }else if(resource === 'rawMaterial' ){
        return fixGetManyRawMaterial(json);
      }else if(resource === 'productCapacity'){
        return fixGetManyProductCapacity(json);

      }else if(resource === 'eventPanle'){
        return fixGetManyEventPanel(json);

      }
      return {
        data: {...json, id: json.objectId},
      };
    }
    
  );
}